import React from "react";
import {
  // FaInstagram,
  FaLinkedin,
  // FaFacebook,
  // FaTwitter,
  // FaYoutube,
  FaGithub,
} from "react-icons/fa";
import {
  FooterContainer,
  // FooterLink,
  FooterLinkItems,
  FooterLinksContainer,
  FooterLinksWrapper,
  // FooterLinkTitle,
  FooterWrap,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  // WebsiteRights,
  SocialIcons,
  SocialIconLink,
} from "./FooterElements";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrap>
        <FooterLinksContainer>
          <FooterLinksWrapper>
            <FooterLinkItems>
              {/* <FooterLinkTitle>Contact me!</FooterLinkTitle>
              <FooterLink to="/">Coming soon!</FooterLink> */}
            </FooterLinkItems>
          </FooterLinksWrapper>
        </FooterLinksContainer>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialLogo to="/">Thank you for your time</SocialLogo>
            {/* <WebsiteRights>
              Matt © {new Date().getFullYear()}
            </WebsiteRights> */}
            <SocialIcons>
              <SocialIconLink href="https://www.github.com/matthewraylee/" target="_blank" aria-label="Github">
                <FaGithub />
              </SocialIconLink>
              <SocialIconLink href="https://www.linkedin.com/in/matthewraylee/" target="_blank" aria-label="LinkedIn">
                <FaLinkedin />
              </SocialIconLink>
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
